import {
    Dialog, DialogContent, DialogTitle, Grid, IconButton, InputAdornment,
    styled, TextField, Tooltip, Typography, Box,
} from '@mui/material'
import ButtonComponent from '../../../../common/components/button/Button'
import {
    checkPermission,
    executeWithTryCatch,
    gettingCompanyId,
    isNullOrEmpty,
    isResponseSuccess,
    normalizeApiResponse,
    requiredLabel,
    trimString,
} from '../../../../helpers/HelperFunctions'
import { useFormik } from 'formik'
import { DirectRoutingConfigFormValidation } from '../../../../validations/ServicesValidation'
import { PERMISSIONS, TOAST_MESSAGES } from '../../../../helpers/Constants'
import { useState, useMemo, useEffect } from 'react'
import { postDRConfiguration } from '../../../../api/post/postApi'
import { useToastContext } from '../../../../App'
import jwt_decode from 'jwt-decode'
import { useSearchParams } from 'react-router-dom'
import { useCommonRedux } from '../../../../store/middlewares/CommonRedux'
import GppGoodIcon from '@mui/icons-material/GppGood'
import ConfirmationModal from '../../../../common/components/custom/modal/modal'
import { setIsOrderActivatedView } from '../../../../store/slice/homeSlice'
import { useHomeRedux } from '../../Home'
import { api_generateM365License } from '../../../../api/master/masterAPI'
import { api_AssignVoiceRoutePolicy } from '../../../../api/services/TeamsPhoneSolutionsAPI'
import {
    serviceSliceState,
    setConfiguration,
} from '../../../../store/slice/serviceSlice'
import SkeletonTableLoader from '../../../../common/components/loaders/skeletonLoader'
import { getCustomerConfiguration } from '../../../../api/get/getApi'
import { useSelector } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import { LOCAL_STORAGE_TEMP_CONFIG } from '../../../../helpers/constants/AuthConstants'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
    setIsLicenseGenerated,
} from '../../../../store/slice/commonSlice'


import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { BiCog } from "react-icons/bi";
import { customerProvisioningStatusesGet } from '../../../../api/orders/ordersAPI'

const FlexContainer = styled(Grid)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '10px 0',
})

const FlexButtonContainer = styled(Grid)({
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 0',
})
const CustomTextField = styled(TextField)({
    '& .MuiFormHelperText-root': {
        fontSize: '12px', // Adjust the font size as needed
    },
})

// --- Reusable helpers --- //
const showErrorToast = (toast, error, setBtnLoading, key) => {
    toast.showToast(normalizeApiResponse(error)?.message, 'error')
    if (setBtnLoading && key) {
        setBtnLoading((prev) => ({ ...prev, [key]: false }))
    }
}

const updateLoading = (setState, key, value) => {
    setState((prev) => ({ ...prev, [key]: value }))

}

const cleanupLocalStorage = (companyId) => {
    ['OrderActivated', 'isAlreadyActivated', 'oid', 'ct',
        LOCAL_STORAGE_TEMP_CONFIG.concat(companyId)].forEach(item =>
            localStorage.removeItem(item)
        )
}

const resolveCompanyId = (searchParams) => {
    const token = localStorage.getItem('sd_cp.jwt:tkn')
    if (!token) return null
    const decoded = jwt_decode(token)
    return searchParams.get('company_id') || decoded?.company_id
}


const steps = ['Grant Consent', 'Connect Microsoft', 'Domain created'];

function HorizontalLinearStepper(props) {
    const { hasConsentTrue, isSubmitCompleted, completedSteps, connectToMicrosoft } = props;

    const activeStep = isSubmitCompleted
        ? completedSteps
        : hasConsentTrue
            ? 1
            : 0;

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    let isCompleted = false;

                    // Step 0 → Grant Consent
                    if (index === 0) { isCompleted = hasConsentTrue; }
                    // Connect Microsoft
                    if (index == 1) { isCompleted = connectToMicrosoft; }
                    // Check Domain creation
                    if (index == 2) { isCompleted = completedSteps >= 1; }

                    return (
                        <Step key={label} completed={isCompleted}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}



function DirectRoutingLegacyConfigDialog(props) {
    const {
        onClose,
        onChange,
        serviceName,
        goToServiceFunction,
        updateAdministrate,
        isProvisioningStarting
    } = props
    const [btnLoading, setBtnLoading] = useState({
        saveLoading: false,
        generateLicenseLoading: false,
        submitLoading: false,
    });

    const [hasProvisioning, setHasProvisioning] = useState([]);
    const [hasDomainCreated, setHasDomainCreated] = useState(null);
    const [isSubmitCompleted, setIsSubmitCompleted] = useState(true);
    const serviceState = useSelector(serviceSliceState)
    const { toast } = useToastContext()
    const [searchParams] = useSearchParams()
    const { dispatch } = useHomeRedux()
    const [showPassword, setshowPassword] = useState(false)
    const { state: commonState } = useCommonRedux()
    const [showConsentAlert, setShowConsentAlert] = useState(false)
    const [showPasswordEdit, setShowPasswordEdit] = useState(
        !serviceState.configuration?.userName
    )
    const [isWaitingForConsent, setIsWaitingForConsent] = useState(false);
    const [licenseResponse, setLicenseResponse] = useState({})
    const [isSaved, setIsSaved] = useState(false)
    const [isRefreshConfig, setIsRefreshConfig] = useState(false)
    const [showEditButton, setShowEditButton] = useState(
        serviceState.configuration?.username !== null
    );


    const initialPassword = serviceState.configuration?.username ? '*******' : ''
    let intervalId = null
    const [staticPassword, setStaticPassword] = useState(initialPassword)
    const initialValues = useMemo(
        () => ({
            sbcPrefix: serviceState.configuration?.sbcPrefix?.replace("-sdc", "") || '',
            userName: serviceState.configuration?.username || '',
            password: serviceState.configuration?.username ? '' : staticPassword,
            tenantId: serviceState.configuration?.aadTenantId || ''
        }),
        [serviceState.configuration, staticPassword]
    )

    const formik = useFormik({
        initialValues,
        validationSchema: DirectRoutingConfigFormValidation,
        validateOnChange: true,
        onSubmit: () => handleConfigSubmit(),
    })

    useEffect(() => {
        getProvisioningStatus();
    }, [])

    useEffect(() => {
        if (isRefreshConfig) {
            intervalId = setInterval(() => {
                executeWithTryCatch(getConfigurationDetails, handleGetConfigError)
            }, 3000)
        }
        return () => clearInterval(intervalId)
    }, [isRefreshConfig])

    const handleGetConfigError = (error) => {
        toast.showToast(normalizeApiResponse(error)?.message, 'error')
        setIsRefreshConfig(false)
        clearInterval(intervalId)
    }

    // get provisioning status
    const getProvisioningStatus = async () => {
        const companyId = gettingCompanyId()
        const response = await customerProvisioningStatusesGet(
            { companyId },
            companyId
        )
        setHasProvisioning(response?.data)
    }

    const handleConfigSubmit = async () => {
        try {
            setIsRefreshConfig(true);
            updateLoading(setBtnLoading, 'submitLoading', true);
            setIsSubmitCompleted(false);
            const saveResult = await handleSave(formik.values);
            if (!saveResult?.success) {
                toast.showToast(
                    saveResult?.response?.data?.message || saveResult?.message,
                    'error'
                );
                return;
            }

            // ✅ Wait for consent
            setIsWaitingForConsent(true);
        } catch (error) {
            toast.showToast(error.message || "Something went wrong", 'error');
        } finally {
            updateLoading(setBtnLoading, 'submitLoading', false);
        }
    };


    const getConfigurationDetails = async () => {
        const response = await getCustomerConfiguration(resolveCompanyId(searchParams));
        if (!isResponseSuccess(response)) return;

        const isAppConsented = response?.data?.result?.isAppConsented;

        if (isAppConsented) {
            clearInterval(intervalId);
            // setIsRefreshConfig(false);
            setIsWaitingForConsent(false);

            dispatch(setConfiguration(response.data.result));
            toast.showToast(TOAST_MESSAGES.PermissionGranted, 'success');

            // generate license for new tenantId
            if (serviceState?.configuration?.aadTenantId !== formik.values.tenantId
                || !serviceState?.configuration?.m365License || hasProvisioning?.length == 0) {
                //🚀 Start license → policy chain
                await generateLicenseAndAssignPolicy();
            } else {
                // stop the execution after consent
                setIsRefreshConfig(false);
                updateLoading(setBtnLoading, 'submitLoading', false);
                setIsSubmitCompleted(true);
            }
        }
    };

    const generateLicenseAndAssignPolicy = async () => {
        try {
            updateLoading(setBtnLoading, 'submitLoading', true);

            // Step 1️⃣ Generate License
            const licenseResponse = await generateM365License();
            if (!licenseResponse) {
                toast.showToast('License generation failed', 'error');
                return;
            }

            // Step 2️⃣ Assign Voice Route Policy
            const companyId = resolveCompanyId(searchParams);
            const localConfig = localStorage.getItem(
                LOCAL_STORAGE_TEMP_CONFIG.concat(companyId)
            );
            const config = isNullOrEmpty(localConfig) ? null : JSON.parse(localConfig);

            const payload = {
                companyId,
                sbcPrefix: formik.values.sbcPrefix,
                username: formik.values.userName,
                tenantId: formik.values.tenantId,
                domainEast: licenseResponse?.domainEast ?? config?.domainEast,
                domainWest: licenseResponse?.domainWest ?? config?.domainWest,
                tempUserId: licenseResponse?.tempUserId ?? config?.tempUserId + '',
            };

            const response = await api_AssignVoiceRoutePolicy(payload, companyId);

            if (response.data.result?.automationDeploymentStatus > 0 || response.data?.status == 200) {
                dispatch(setIsOrderActivatedView(false));
                onChange?.();
                dispatch(setConfiguration({
                    ...serviceState.configuration,
                    createAndAssignVoiceRoutePolicy: true,
                }));
            }

            cleanupLocalStorage(companyId);
            toast.showToast(
                response.data?.message || TOAST_MESSAGES.DeploymentCompleted,
                'success'
            );

            getProvisioningStatus();
            setIsSubmitCompleted(true);
            setTimeout(() => {
                onClose?.();
                goToServiceFunction('list');
                goToServiceFunction('DRlist');
            }, 2000);

        } catch (error) {
            handleVoicePolicyAssignmentError(error);
        } finally {
            updateLoading(setBtnLoading, 'submitLoading', false);
        }
    };


    const handleVoicePolicyAssignmentError = (error) => {
        updateLoading(setBtnLoading, 'submitLoading', false)
        toast.showToast(normalizeApiResponse(error)?.message || error?.response?.data?.message, 'error')
    }


    // generate license
    const generateM365License = async () => {
        updateLoading(setBtnLoading, 'generateLicenseLoading', true);
        const companyId = resolveCompanyId(searchParams);
        try {

            const request = { companyId, tenantId: formik.values.tenantId };
            const response = await api_generateM365License(request);

            // ✅ Update local state and Redux
            setLicenseResponse(response.data.result);
            dispatch(setConfiguration({
                ...serviceState.configuration,
                m365License: response.data?.result?.license,
            }));

            // ✅ Save in localStorage for later reference
            localStorage.setItem(
                LOCAL_STORAGE_TEMP_CONFIG.concat(companyId),
                JSON.stringify(response.data.result)
            );
            updateLoading(setBtnLoading, 'generateLicenseLoading', false);
            dispatch(setIsLicenseGenerated(!!response.data?.result?.license));
            getProvisioningStatus()
            return response.data.result; // ✅ Return license info for next API
        } catch (err) {
            handleGenerateLicenseError(err);
            updateLoading(setBtnLoading, 'generateLicenseLoading', false);
            return err // ✅ Throw so caller can handle failure
        }

    };


    const handleGenerateLicenseError = (error) => {
        toast.showToast(normalizeApiResponse(error)?.message, 'error')
        dispatch(setIsLicenseGenerated(false))
        updateLoading(setBtnLoading, 'generateLicenseLoading', false)
    }

    // Authenticate credentials
    const handleSave = async (values) => {

        updateLoading(setBtnLoading, 'saveLoading', true);
        const companyId = resolveCompanyId(searchParams);
        setShowEditButton(true);
        setshowPassword(false);
        try {

            const payload = {
                ...values,
                tenantId: trimString(values.tenantId),
                userName: trimString(values.userName),
                companyId,
                env: process.env.REACT_APP_ENV,
            };

            setStaticPassword('*******');

            const response = await postDRConfiguration(payload);
            if (!response) throw new Error('DR Configuration failed');

            dispatch(setIsLicenseGenerated(false));
            dispatch(setConfiguration(response?.data.result));

            const configResponse = await getCustomerConfiguration(companyId);
            if (!configResponse) throw new Error('Customer configuration fetch failed');

            setIsSaved(true);
            dispatch(setConfiguration({
                ...configResponse.data.result,
                userName: configResponse.data.result.username,
                aadTenantId: configResponse.data.result.aadTenantId,
            }));
            setIsRefreshConfig(true);
            window.open(configResponse.data.result?.consentUrl, '_blank');
            updateLoading(setBtnLoading, 'saveLoading', false);

            formik.setFieldValue('password', '*');
            getProvisioningStatus();
            return { success: true, data: configResponse.data.result }; // ✅ Return value
        } catch (err) {
            showErrorToast(toast, err, setBtnLoading, 'saveLoading');
            updateLoading(setBtnLoading, 'saveLoading', false);
            return err
        }
    };


    const handleInputChange = (e) => {
        formik.handleChange(e)
        setIsSaved(false)
        dispatch(
            setConfiguration({
                ...serviceState.configuration,
                [e.target.name]: e.target.value,
            })
        )
    }
    const handleEdit = () => {
        setShowEditButton(false)
        setStaticPassword('')
        formik.setFieldValue('password', '')
    }

    const handleGrantPermission = () => {
        const { consentUrl } = serviceState.configuration;
        if (consentUrl) {
            setIsRefreshConfig(true)
            window.open(consentUrl, '_blank')
        } else {
            // setIsRefreshConfig(false)
            setShowConsentAlert(true)
        }
    }

    return (
        <Dialog open maxWidth="sx">
            <DialogTitle>

                <FlexContainer>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <IconButton aria-label="close" sx={{ boxShadow: 2, borderRadius: 2 }} >
                            <BiCog />
                        </IconButton>

                        <Tooltip title="Grant Permission">
                            <IconButton
                                disable={true}
                                onClick={
                                    !serviceState.configuration?.isAppConsented &&
                                    handleGrantPermission
                                }
                                disableRipple={serviceState.configuration?.isAppConsented}
                                sx={{ padding: 0 }}
                            >
                                {/* Once IsAppConsented is working fine after that remove this comment and the remove code isSaved */}
                                <GppGoodIcon
                                    color={serviceState.configuration?.isAppConsented
                                        ? 'success'
                                        : 'default'
                                    }
                                />
                            </IconButton>
                        </Tooltip>

                    </Box>
                    <Box>{isProvisioningStarting ? "Automated Provisioning" : "Teams Configuration"}</Box>
                    <Typography> Manage Accounts for Teams Phone solution</Typography>
                </FlexContainer>

            </DialogTitle>

            <form onSubmit={formik.handleSubmit}>
                <DialogContent sx={{ width: '450px', textAlign: 'center' }}>
                    {props?.isLoading ? (
                        <SkeletonTableLoader value={5} />
                    ) : (
                        <>
                            {checkPermission(
                                [
                                    PERMISSIONS.masterSettingUpdate,
                                    PERMISSIONS.serviceproviderSettingUpdate,
                                    PERMISSIONS.resellerSettingUpdate,
                                    PERMISSIONS.customerSettingUpdate,
                                ],
                                commonState.currentCompanyDetails
                            ) && (

                                    null
                                )}
                            {/* ✅ Domain Field */}
                            <FlexContainer sx={{ width: "100%" }}>
                                <Grid container direction="column" spacing={1}>
                                    <Grid item>
                                        <Typography>{requiredLabel('Domain', true)}</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: "100%" }}>
                                        <CustomTextField
                                            fullWidth
                                            id="sbcPrefix"
                                            name="sbcPrefix"
                                            size="small"
                                            disabled
                                            value={formik.values.sbcPrefix}
                                            onChange={formik.handleChange}
                                            error={formik.touched.sbcPrefix && Boolean(formik.errors.sbcPrefix)}
                                            helperText={formik.touched.sbcPrefix && formik.errors.sbcPrefix}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                            </FlexContainer>
                            {/* ✅ Admin Field */}
                            <FlexContainer sx={{ width: "100%" }}>
                                <Grid container direction="column" spacing={1}>
                                    <Grid item>
                                        <Typography>{requiredLabel('Microsoft Admin Account', true)}</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: "100%" }}>
                                        <CustomTextField
                                            fullWidth
                                            id="userName"
                                            name="userName"
                                            size="small"
                                            // autoComplete="off"
                                            value={formik.values.userName}
                                            onChange={handleInputChange}
                                            error={formik.touched.userName && Boolean(formik.errors.userName)}
                                            helperText={formik.touched.userName && formik.errors.userName}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                            </FlexContainer>

                            {/* ✅ Password Field */}
                            <FlexContainer sx={{ width: "100%" }}>
                                <Grid container direction="column" spacing={1}>
                                    <Grid item>
                                        <Typography>{requiredLabel('Password', true)}</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: "100%" }}>
                                        <CustomTextField
                                            fullWidth
                                            id="password"
                                            name="password"
                                            size="small"
                                            autoComplete="off"
                                            disabled={showEditButton}
                                            placeholder={!showEditButton ? '' : staticPassword || '*******'}
                                            type={showPassword ? 'text' : 'password'}
                                            value={showEditButton ? '' : formik.values.password}
                                            onChange={handleInputChange}
                                            error={formik.touched.password && Boolean(formik.errors.password)}
                                            helperText={formik.touched.password && formik.errors.password}
                                            onBlur={formik.handleBlur}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {formik.values?.password?.length > 0 && serviceState.configuration?.password !== null && (
                                                            <IconButton onClick={() => setshowPassword(!showPassword)} edge="end">
                                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                                            </IconButton>
                                                        )}
                                                        {(serviceState.configuration?.username && formik.values?.password?.length === 0) || isSaved ? (
                                                            <IconButton onClick={handleEdit}
                                                                aria-label="edit"
                                                                style={{
                                                                    float: 'end',
                                                                    borderRadius: 0,
                                                                    fontSize: '20px',
                                                                }}>
                                                                <EditIcon style={{
                                                                    fontSize: '15px',
                                                                    verticalAlign: 'end',
                                                                    margin: '0 0px 0 0px',
                                                                }} />
                                                            </IconButton>
                                                        ) : null}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </FlexContainer>

                            {/* ✅ Tenant ID */}
                            <FlexContainer sx={{ width: "100%" }}>
                                <Grid container direction="column" spacing={1}>
                                    <Grid item>
                                        <Typography>{requiredLabel('Tenant ID', true)}</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: "100%" }}>
                                        <CustomTextField
                                            fullWidth
                                            id="tenantId"
                                            name="tenantId"
                                            size="small"
                                            sx={{ flexGrow: 1 }}
                                            value={formik.values.tenantId}
                                            onChange={handleInputChange}
                                            error={formik.touched.tenantId && Boolean(formik.errors.tenantId)}
                                            helperText={formik.touched.tenantId && formik.errors.tenantId}
                                            onBlur={formik.handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                            </FlexContainer>

                        </>
                    )}
                </DialogContent>

                <HorizontalLinearStepper
                    completedSteps={hasProvisioning.length}
                    isSubmitCompleted={isSubmitCompleted}
                    hasConsentTrue={serviceState?.configuration?.isAppConsented}
                    connectToMicrosoft={serviceState?.configuration?.m365License}
                />

                {/* ✅ Actions */}
                <Box sx={{ p: 2 }}>
                    <FlexButtonContainer gap={1}>
                        <ButtonComponent text="Cancel" color="primary" variant="outlined" onClick={onClose} />
                        <ButtonComponent
                            color="primary"
                            variant="contained"
                            text='Submit'
                            type='submit'
                            loading={btnLoading?.saveLoading ||
                                btnLoading?.generateLicenseLoading ||
                                btnLoading?.submitLoading}
                            onClick={() => handleConfigSubmit()}
                        />

                    </FlexButtonContainer>
                </Box>
            </form>
            <ConfirmationModal
                title="Info"
                content={`Please set your Azure AD Tenant Id to grant admin consent!`}
                isOpen={showConsentAlert}
                hiddenConform={true}
                handleClose={() => setShowConsentAlert(false)}
            />
        </Dialog>
    )
}

export default DirectRoutingLegacyConfigDialog
